export default "__VITE_ASSET__gs0jqLKA__"